module.exports = __webpack_public_path__ + "static/img/32.69eee93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/32.png
// module id = nYkd
// module chunks = 0